import Vue from "vue";
import Router from "vue-router";
import Main from "./views/Main.vue";
import ThankYou from "./views/ThankYou.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    { path: "/", name: "home", component: Main },
    { path: "/thankyou", name: "ThankYou", component: ThankYou },
    // { path: "/:code/:check", name: "paycheck", component: () => import("./components/PayCheck.vue"), props: true },
    // { path: "*", redirect: "/" } // catch all use case
  ]
});

